
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.984 0c-2.35 0-4.27.736-5.761 2.207C.74 3.678 0 5.598 0 7.969c0 2.38.76 4.311 2.283 5.793C3.816 15.253 5.777 16 8.168 16c2.258 0 4.123-.675 5.594-2.023 1.087-.997 1.77-2.26 2.054-3.788h.006l.004-.037a9.415 9.415 0 00.143-1.677v-.26h-.016c0-.496-.027-1-.13-1.47-.133-.597-.392-1.23-.901-1.72-.529-.509-1.23-.77-2.059-.787-1.58-.03-2.905.937-3.861 1.938-.425.445-.802.93-1.14 1.412L6.3 6.06 4.893 7.467l3.324 3.344.043.044s.113-.26.275-.576c.417-.809 1.097-1.883 1.904-2.728.834-.873 1.652-1.339 2.385-1.324.413.008.608.126.719.232.13.125.254.344.336.715.157.708.084 1.628-.014 2.531-.076.43-.185.834-.332 1.207-.296.777-.716 1.394-1.258 1.854-.53.47-1.14.818-1.824 1.043-.674.235-1.419.351-2.236.351-1.86 0-3.367-.556-4.522-1.67-1.144-1.103-1.716-2.605-1.716-4.506 0-1.91.558-3.412 1.671-4.505 1.124-1.094 2.59-1.64 4.399-1.64 1.062 0 2 .19 2.818.567l.383-1.793C10.278.205 9.19 0 7.984 0z"}})])
          )
        }
      }
    